import { DatePicker, Modal, Pagination, Tooltip } from "antd";
import React, { useRef, useState, useEffect } from "react";
import moment from "moment";
import "./misreport.css";
import { useDispatch, useSelector } from "react-redux";
import StatusBadge from "../Badges/StatusBadge/StatusBadge";
import { downloadSummaryReport, FETCH_ADMIN_DASHBOARD_REPORT, FETCH_ADMIN_DETAILED_REPORT, FETCH_DASHBOARD_MORE, FETCH_DETAILED_MORE, updateMisReportComment } from "../../actions/InterbranchAdminActions";
import { INTERBRANCH_MODAL } from "../../actions/type";
import { convertDateToString } from "../../Helpers/dateFunctions";
import { getConsultationStatusFlag } from "../../Helpers/ClinicAdminHelper";
import EmptyTableData from "../Common/EmptyTableData/EmptyTableData";
import ResetFilterButton from "../InterbranchAdminComponents/ResetFilterButton/ResetFilterButton";
import Spinner from "react-bootstrap/Spinner";
import AppDatePicker from "../UI/app-date-picker/AppDatePicker";

const { RangePicker } = DatePicker;

function Misreport() {
	const dateRef = useRef(null);
	let [activePage, setActivePage] = useState(1);
	let [isOpen, setOpen] = useState(false);
	let [selectedDate, setSelectedDate] = useState({ from: null, to: null });
	let [loader, setLoader] = useState(true);
	let [isInitial, setinitial] = useState(true);
	const [misReports, setMisReports] = useState([]);
	let [misReportsPageLength, setmisReportsPageLength] = useState(true);
	const dispatch = useDispatch();
	const userData = JSON.parse(localStorage.getItem("userData"));
	const [selectedRange, setSelectedRange] = useState(null);
	// let misReports =useSelector(state => state.interbranchAdmin.detailedReportTable)
	// let misReportsPageLength =useSelector(state => state.interbranchAdmin.detailedReportTableTotalPages)
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		setLoader(true);
		dispatch(FETCH_ADMIN_DETAILED_REPORT({ offset: activePage - 1 })).then((res) => {
			console.log("res", res);
			setMisReports(res.data);
			setmisReportsPageLength(res.totalNumberOfPages);
			setLoader(false);
		});
	}, []);

	let handleTableClick = (_id) => {
		dispatch(FETCH_DETAILED_MORE(_id));

		dispatch({
			type: INTERBRANCH_MODAL,
			payload: {
				name: "misReportModal",
				value: true,
			},
		});
	};

	let filterOnClick = () => {
		setOpen(!isOpen);
	};

	let handledateChange = (e) => {
		setSelectedRange(e);
		if (e) {
			let [startDate, endDate] = e;

			let prevDate = moment().subtract(3, "months");

			console.log(convertDateToString(startDate));

			console.log("startDate, endDate", startDate, endDate);

			if (startDate < prevDate) {
				Modal.confirm({
					title: "Confirm",
					// icon: <ExclamationCircleOutlined />,
					content: "You can only view report within a 3 month span. Do you want to download the report before 3 months?",
					okText: "Download Report",
					cancelText: "cancel",
					onOk() {
						dispatch(
							downloadSummaryReport({
								fromDate: startDate,
								toDate: endDate,
							})
						).then((resp) => {
							if (resp) {
								window.open(resp, "_blank");
							}
						});
					},
				});
			} else {
				setSelectedDate({ from: startDate, to: endDate });
				dispatch(FETCH_ADMIN_DETAILED_REPORT({ fromDate: startDate, toDate: endDate })).then((res) => {
					console.log("res", res);
					setMisReports(res.data);
					setmisReportsPageLength(res.totalNumberOfPages);
				});
				//downloadReport(startDate, endDate)
			}
		}
	};

	let downloadReport = () => {
		console.log("Downloading report..............");
		setIsLoading(true);
		dispatch(
			downloadSummaryReport({
				fromDate: selectedDate.from,
				toDate: selectedDate.to,
			})
		).then((resp) => {
			if (resp) {
				window.open(resp, "_blank");
			}
			setIsLoading(false);
		});
	};

	let handleCommentChange = (para_appointment_id, e) => {
		dispatch(updateMisReportComment(para_appointment_id, e.target.value)).then((res) => {
			if (res) {
				dispatch(FETCH_ADMIN_DETAILED_REPORT());
			}
		});
	};
	console.log("selectedDate", selectedDate.from);
	console.log("selectedDateTo", selectedDate.to);

	let handlePaginationChange = (e) => {
		// console.log(e-1);
		setActivePage(e);
		if (selectedDate.from === undefined && selectedDate.from === "") {
			dispatch(FETCH_ADMIN_DETAILED_REPORT({ offset: e - 1 })).then((res) => {
				console.log("resPage", res);
				setMisReports(res.data);
				//setmisReportsPageLength(res.totalNumberOfPages)
			});
		} else {
			dispatch(
				FETCH_ADMIN_DETAILED_REPORT({
					fromDate: selectedDate.from,
					toDate: selectedDate.to,
					offset: e - 1,
				})
			).then((res) => {
				console.log("resPage2", res);
				setMisReports(res.data);
				// setmisReportsPageLength(res.totalNumberOfPages)
			});
		}
	};

	const resetFilterAction = () => {
		setActivePage(1);
		dispatch(FETCH_ADMIN_DETAILED_REPORT({ offset: 0 })).then((res) => {
			console.log("res", res);
			setMisReports(res.data);
			setmisReportsPageLength(res.totalNumberOfPages);
			setLoader(false);
		});
		setSelectedRange(null);
	};

	return (
		<div className="mis_report_container">
			<div className="header">
				<button
					className="button"
					onClick={() => {
						downloadReport();
					}}
				>
					<>
						<div className="icon">
							{isLoading ? (
								<Spinner
									style={{
										width: "20px",
										height: "20px",
										color: "black",
									}}
									animation="border"
									role="status"
								></Spinner>
							) : (
								<i className="far fa-download"></i>
							)}
						</div>
						Download Report
					</>
				</button>

				

				 <div className="d-flex flex-row align-items-center">
					<div className="filter-button">
						<div className="icon" onClick={filterOnClick}>
							<i class="far fa-calendar-alt"></i>
						</div>

						<RangePicker
							// open={isOpen}
							allowClear={false}
							//value={selectedDate}
							ref={dateRef}
							bordered={false}
							className="date-picker"
							format="DD-MMM-YYYY"
							suffixIcon={null}
							value={selectedRange}
							// disabledDate={(current) => {
							//     let customDate = moment().format("YYYY-MM-DD");
							//     return current && current > moment(customDate, "YYYY-MM-DD");
							//   }}
							onChange={handledateChange}
						/>
					</div>
					<ResetFilterButton visibility={selectedRange} handleReset={resetFilterAction} />
				</div> 
			</div>

			<div className="mis_report_table_container">
				<table className="appoinment-table">
					<tr>
						<th>Appoinment ID</th>
						<th>Appoinment Date</th>
						<th>Appointment Time</th>
						<th>Patient Name</th>
						<th>Doctor Name</th>
						<th>Fees Paid</th>
						{/* <th>C2MD Fees</th>
                        <th>Nett Fees</th> */}
						<th>Consultation Status</th>
						<th>Payment Status</th>
						{/* <th>Notes</th> */}
						<th></th>
					</tr>

					<tbody>
						{misReports ? (
							misReports.length > 0 ? (
								misReports.map((element, key) => {
									if (key <= 8) {
										return (
											<tr>
												<td>{element.appointmentId}</td>
												<td>{element.appointmentDate}</td>
												<td>{element.appointmentTime}</td>
												<td>
													<div style={{ display: "flex", flexDirection: "column" }}>
														<span>{element.patientName}</span>
														{/* <span>
                              ({element.patientGender},{" "}
                              {(() => {
                                const dob = element.patientDob;
                                const dobDate = new Date(dob);
                                const currentDate = new Date();
                                const ageInMonths = Math.floor(
                                  (currentDate - dobDate) /
                                    (1000 * 60 * 60 * 24 * 30.4375)
                                ); // Average number of days in a month
                                const ageInYears = Math.floor(ageInMonths / 12);

                                if (ageInMonths < 1) {
                                  return `1 month`;
                                } else if (ageInMonths < 12) {
                                  return `${ageInMonths} months`;
                                } else {
                                  return `${ageInYears} years`;
                                }
                              })()}
                              )
                            </span> */}
													</div>
												</td>
												<td>{element.doctorName}</td>

												{/* <td>{element.feesPaid}</td>
                                                    <td>{element.c2mdFees}</td> */}
												<td>{element.feesPaid}</td>
												<td>
													<StatusBadge text={element.consultationStatus} varient={getConsultationStatusFlag(element.consultationStatus)} />
												</td>

												<td>{element.paymentStatus !== "N/A" ? element.paymentStatus : "NA"}</td>
												{/* <td><textArea onBlur={(e)=>{handleCommentChange(element.appointmentId,e)}} rows={1} >{element.Comments}</textArea></td> */}

												<td>
													<button
														onClick={() => {
															handleTableClick(element.appointmentId);
														}}
														className="more-btn"
													>
														More
													</button>
												</td>
											</tr>
										);
									}
								})
							) : (
								<tr>
									<td colSpan={9}>
										<EmptyTableData isLoading={loader} haveButton={false} text={isInitial && "LOOKS LIKE NO APPOINTMENT HAVE BEEN CREATED YET"} caption={""} />
									</td>
								</tr>
							)
						) : null}
					</tbody>
				</table>
			</div>

			{misReports.length > 0 && (
				<div className="pagination-container-mis-report">
					&nbsp;
					<Pagination showSizeChanger={false} onChange={handlePaginationChange} defaultCurrent={1} total={misReportsPageLength ? misReportsPageLength * 8 : 0} />
				</div>
			)}
		</div>
	);
}

export default Misreport;
